// extracted by mini-css-extract-plugin
export default {"container":"Products_container__msuhv","products":"Products_products__Wh25R","menu":"Products_menu__fTNOi","list":"Products_list__naMca","product":"Products_product__TJjw8"};